<img *ngIf="moonPhase > 0 && moonPhase < 29"
     [src]="moonPhaseUrl"
     alt="Current moon phase"
     class="moon"/>
